
import { Vue } from "vue-class-component";

export default class DexAssessment extends Vue {}
